import { Finish, RawMaterial, CustomMaterial as V3CustomMaterial } from '../../__generated/admin-model/versions/v3.js';
export const migrateToV4 = (state)=>{
    return state.map((entity)=>{
        if (V3CustomMaterial.is(entity)) {
            const isStainlessSteel = entity.rawMaterial === RawMaterial.ss304 || entity.rawMaterial === RawMaterial.ss316;
            const isPowderCoatingMaterial = isStainlessSteel || entity.rawMaterial === RawMaterial.aluminium;
            return {
                ...entity,
                powderCoatingEnabled: entity.thickness >= 1.2 && isPowderCoatingMaterial && (!isStainlessSteel || entity.finish !== Finish.brushed)
            };
        }
        return entity;
    });
};

//# sourceMappingURL=v4.js.map